export class CVFleetSpecificationModel {
  lineTractorEstimatedMonthlyKm: number = 0;
  maneuverTractorEstimatedMonthlyKm: number = 0;
  tractorEstimatedMonthlyKm: number = 0;
  arlaCost: number = 0;
  anpDieselCost: number = 0;
  anpDieselWithArlaCost: number = 0;
}
